
import React from 'react';
import { Link } from 'react-router-dom';

const VirtualCareSection: React.FC = () => {
  const features = [
    {
      icon: 'ri-time-line',
      title: '24-Hour Response',
      description: 'Get medical answers within 24 hours, guaranteed'
    },
    {
      icon: 'ri-video-chat-line',
      title: 'Virtual Consultations',
      description: 'Face-to-face consultations from anywhere'
    },
    {
      icon: 'ri-medicine-bottle-line',
      title: 'Prescription Management',
      description: 'Easy prescription refills and management'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'HIPAA Compliant',
      description: 'Your health data is secure and protected'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Why Choose <strong>Virtual Primary Care</strong>?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Experience healthcare reimagined with our subscription-based virtual primary care service designed for modern lifestyles.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-12 lg:mb-16">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 lg:p-8 bg-gray-50 rounded-2xl hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 lg:w-20 lg:h-20 bg-gradient-to-r from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 lg:mb-6">
                <i className={`${feature.icon} text-2xl lg:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg lg:text-xl font-semibold text-gray-900 mb-3 lg:mb-4">{feature.title}</h3>
              <p className="text-sm lg:text-base text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl lg:rounded-3xl p-8 lg:p-12 text-center text-white">
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 lg:mb-6">
            Ready to Transform Your Healthcare?
          </h3>
          <p className="text-lg lg:text-xl mb-6 lg:mb-8 opacity-90 max-w-2xl mx-auto">
            Join thousands of patients who have already made the switch to convenient, comprehensive virtual primary care.
          </p>
          <Link
            to="/virtual-primary-care"
            className="inline-block bg-white text-teal-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            View Subscription Plans
          </Link>
        </div>
      </div>
    </section>
  );
};

export default VirtualCareSection;
